import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractTransactionSerie } from "../_types/contract-transaction-serie";

@Injectable({
    providedIn: 'root',
})
export class ContractTransactionSeriesService extends Service<ContractTransactionSerie> {
  public override type = 'contractTransactionSeries';
  public override url = 'attendance/contractTransactionSeries';  
}